import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";

const MobileSidebar = ({ open, toggleSidebar, sidebarData, isProfilePage }) => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);
  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={toggleSidebar}
      onOpen={toggleSidebar}
    >
      <Box
        sx={{
          width: 250,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
        role="presentation"
        onClick={toggleSidebar}
        onKeyDown={toggleSidebar}
      >
        <List>
          <img
            src={require("../../assets/icons/logo_sm.png")}
            alt=""
            style={{
              margin: "15px 20px",
              height: "50px",
            }}
          />
          {sidebarData.map((item) => {
            const IconComponent = open ? item.FocusedIcon : item.Icon;
            return (
              <ListItem sx={{ height: "60px" }} key={item.id}>
                <ListItemButton
                  sx={{ padding: 0 }}
                  onClick={() => navigate(item.route)}
                >
                  <ListItemIcon
                    sx={{
                      color: colors.primary,
                      minWidth: "auto",
                      mr: open ? 2 : 0,
                    }}
                  >
                    <IconComponent />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{
                      sx: {
                        whiteSpace: "pre-line",
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
        <Box
          sx={{
            m: 2,
            backgroundColor: isProfilePage
              ? colors.secondary
              : "rgba(247,132,25,0.14)",
            p: open ? 1 : 0,
            py: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: open ? "space-between" : "center",
            borderRadius: "9px",
            gap: 1,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(247,132,25,0.3)",
            },
          }}
          onClick={() => navigate("/profile/me")}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <img
              src={
                userData?.avatar || require("../../assets/images/default.jpg")
              }
              alt="avatar"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
              }}
            />
            <Stack direction="column">
              <Typography
                sx={{
                  fontFamily: "Mulish-Bold",
                  color: colors.primary,
                  fontSize: 14,
                  lineHeight: 1.5,
                }}
              >
                {userData?.firstName + " " + userData?.lastName}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Mulish-Regular",
                  color: colors.primary,
                  fontSize: 10,
                  lineHeight: 1.5,
                }}
              >
                Membership since{" "}
                {" " + dayjs(userData?.createdAt).format("YYYY")}
              </Typography>
            </Stack>
          </Stack>
          <IconButton
            sx={{
              color: "#fff",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              "&:hover": {
                backgroundColor: colors.primary + "99",
              },
            }}
            // onClick={handleClick}
          >
            <KeyboardArrowRightOutlined
              sx={{ fontSize: 24, color: colors.primary }}
            />
          </IconButton>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
};

export default MobileSidebar;
